import { render, staticRenderFns } from "./CreateEditPerfilModal.vue?vue&type=template&id=0093834c&"
import script from "./CreateEditPerfilModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditPerfilModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports